import CountDownTrigger from "./../CountDownTrigger.js";
import FrontpageSlider from "../FrontpageSlider";

export default class GeneralEventHandler {
    /**
     * @returns this
     */
    static make() {
        return new this;
    }
    /**
     * @returns this
     */
    addCountDownTimer() {
        let header = jQuery('body header');
        let countDownTimer = header.find('.countdown-timer');
        let countDownTo = String(countDownTimer.data('countdown-to'));
        if (countDownTimer.data('show')) {
            let countDownTrigger = new CountDownTrigger({
                Y: parseInt(countDownTo.substr(0, 4)),
                m: parseInt(countDownTo.substr(5, 2)),
                d: parseInt(countDownTo.substr(8, 2)),
                H: parseInt(countDownTo.substr(11, 2)),
                i: parseInt(countDownTo.substr(14, 2)),
                s: parseInt(countDownTo.substr(17, 2)),
            });
            countDownTrigger.start();
        }
        return this;
    }
    /**
     * @returns this
     */
    addTextSliderAnimation() {
        let slideIndex = 0;
        showSlides();
        function showSlides() {
            let slides = jQuery('.slides');
            slides.each(function() {
                jQuery(this).fadeOut(2000);
            });
            slideIndex++;
            if (slideIndex > slides.length) {slideIndex = 1}
            jQuery(slides[slideIndex-1]).fadeIn(2000);
            setTimeout(showSlides, 5000);
        }
        return this;
    }
    /**
     * @returns this
     */
    showSearchFieldAndSetFocus() {
        // Set focus on the header search input box for quick search
        jQuery('.search-toggle').on('click', function() {
            jQuery(this).hide();
            const $searchFieldWrapper = jQuery('.search-field-wrapper');
            const $searchField = jQuery('.search-field');
            $searchField.val('');
            $searchFieldWrapper.show();
            setTimeout(function() {
                $searchField.focus();

                }, 200);
        });
        return this;
    }
    /**
     * @returns this
     */
    markNewsletterCheckboxDefaultUnchecked() {
        // Mark the newsletter checkbox as unchecked by default during checkout
        jQuery('#noptin_woocommerce_optin_checkbox input').prop('checked', false);
        return this;
    }
    /**
     * @returns this
     */
    collapseCategoryMenuWhenClickedOutside() {
        // Make sure the category menu disappears when we click outside the menu
        let body = jQuery('body');
        body.on('click',function(event){
            if(!jQuery(event.target).is('.cat-nav-trigger')){
                if (body.hasClass('cat-nav-at-navigation-active')) {
                    body.removeClass('cat-nav-at-navigation-active');
                }
            }
        });
        return this;
    }

    /**
     * @returns this
     */
    avoidButtonFlickeringIssueOnFrontpage() {
        // Avoid button flickering CSS issue
        jQuery('.top-boxes .box-title').show();
        return this;
    }

    /**
     * @returns this
     */
    moveCartNoticesElement() {
        jQuery("#cartpops-drawer .cpops-drawer-notices-wrapper").prependTo("#cartpops-drawer .cpops-panel");
        return this;
    }

    /**
     * @returns this
     */
    expandFrontPageImages() {
        jQuery('#image-nav').on('click', function() {
            jQuery(this).closest('.section-group').addClass('expanded-items');
        });
        jQuery(window).on('resize', function() {
            if (jQuery(window).width() >= 600) {
                jQuery('.expanded-items').removeClass('expanded-items');
            }
        });
        return this;
    }

    /**
     * @returns this
     */
    hideGiftPdfCheckboxWhenEmailIsChangedUsingAjax() {
        const that = this;
        const $body = jQuery('body');
        $body.on('updated_checkout', function() {
            that.doHideGiftPdfCheckboxWhenEmailIsChangedUsingAjax(jQuery('input#billing_email'));
        });
        $body.on('change', 'input#billing_email', function() {
            that.doHideGiftPdfCheckboxWhenEmailIsChangedUsingAjax(jQuery(this));
        });
        return this;
    }

    /**
     * @param {jQuery} $billingEmailField
     */
    doHideGiftPdfCheckboxWhenEmailIsChangedUsingAjax($billingEmailField) {
        let email = $billingEmailField.val(); // Get the new email value
        let nonce = orchid_store_kc_params.checkout_nonce;
        jQuery.ajax({
            url: orchid_store_kc_params.ajax_url,
            type: 'POST',
            data: {
                action: 'check_email_for_orders',
                billing_email: email,
                nonce: nonce
            },
            success: function(response) {
                if (response.data.show_field) {
                    jQuery('#noptin_woocommerce_optin_checkbox').show(); // Replace with the actual field selector
                } else {
                    jQuery('#noptin_woocommerce_optin_checkbox').hide(); // Replace with the actual field selector
                }
            }
        });
    }
}
